import React from 'react';
import { CertificationTypeExtendedCombo } from 'areas/shared/controls';
import * as API from 'modules/app/API'
import * as Notifications from 'fw/globals/Notifications';
import * as Modals from 'fw/globals/Modals';
import { ActionButton } from 'fw/components'

class ChangeCertificationType extends React.Component {
    constructor(props) {
        super(props);
        this.state = this.initialState(props);
    }

    initialState = (props) => {
        return {
            visible: props.visible,
            certificationTypeCode: props.certificationTypeCode,
            originalTypeCode: props.certificationTypeCode,
            editMode: false
        };
    }

    handleChange = (c) => {
        this.setState({
            certificationTypeCode: c.value
        });
    }

    handleCancel = () => {
        this.setState({
            editMode: false
        });
    }

    handleEditMode = () => {
        this.setState({
            editMode: true
        });
    }

    handleSave = (e) => {
        const me = this;
        const rq = {
            CertificationId: this.props.certificationId,
            certificationTypeCode: this.state.certificationTypeCode
        };

        Modals.confirm(
            "You are about to force the Certification Type for this Application. <br /><br />" +
            "If you wish to change it, please select 'Yes'. <br /><br />" +
            "If you wish to cancel this action, please select 'No', and you will be returned to the previous screen. ",
            function () {
                this.setState({ error: null }, function () {
                    API.Admin.post('/certification/changeCertificationType', rq,
                        {
                            success: (sr) => {
                                me.handleCancel(); // To reset the editMode state
                                me.props.onChange(sr.data);
                                Notifications.success(sr.message);
                            },
                            error: (sr) => {
                                Notifications.error(sr.error.errorMessage);
                            }
                        });
                });
            })
    }

    render() {
        if (!this.props.certificationId) return null;

        return (
            <React.Fragment>
                <div className="selector-button">
                    <div>
                        {!this.state.editMode &&
                            <ActionButton icon="edit" disabled={this.state.editMode} onClick={this.handleEditMode}>Change Certification Type</ActionButton>
                        }
                        {this.state.editMode &&
                            <React.Fragment>
                                <CertificationTypeExtendedCombo name="certificationTypeCode"
                                    certificationId={this.props.certificationId}
                                    value={this.state.certificationTypeCode}
                                    onChange={(c) => this.handleChange(c)} />
                                <ActionButton icon="ok" disabled={this.state.certificationTypeCode === this.state.originalTypeCode} id="btnSave" bsStyle="success" onClick={this.handleSave}>Change</ActionButton>
                                <ActionButton icon="remove" disabled={!this.state.editMode} onClick={this.handleCancel}>Cancel</ActionButton>
                            </React.Fragment>
                        }
                    </div>
                </div>
            </React.Fragment>
        );
    }
}

export default ChangeCertificationType;


// WEBPACK FOOTER //
// ./src/areas/admin/certification/shared/ChangeCertificationType.js